import { get } from '@yakit/core/objectz'
import growl from '@yakit/ui/growl'
import problemHandler from '@yakit/ui/growl/problemHandler'
import { tempLinkDownloader } from '~/shared/downloader/blobDownloader'
import { getUser } from '~/user'
import CreateEditInfo from '~/common/CreatedInfo.svelte'
import { f7 } from 'framework7-svelte'

/**
 * Customer Dash info endpoints
 */
export function createTranShowController({ user, dataApiFactory, appState }) {
  // $: card1 = transformFields($user.isCustomer ? custConfig.card1 : config.card1)
  // $: card2 = transformFields($user.isCustomer ? custConfig.card2 : config.card2)
  const dataApi = dataApiFactory.ar.tran
  const adJustApi = dataApiFactory.ar.adjust
  const payTranHeader = getPayTranHeader()
  const memoTranHeader = getMemoTranHeader()
  const invTranHeader = getMemoTranHeader(user)

  const disputePopoverSchema = getDisputePopoverSchema()

  const reverse = async (tran) => {
    const results = await dataApi.rpc('reverse', { ids: [tran.id] })
    results.ok ? growl.success(results.title) : problemHandler.handleError(results)
    return results
  }

  const checkImage = async (tran) => {
    const name = get(tran, 'autoCash.imageFileName')
    let path = `autocash/download?name=${name}`
    dataApi
      .ky(path)
      .then((r) => r.blob())
      .then((blob) => {
        const name = path.split('/').slice(-1)[0]
        tempLinkDownloader(blob, name)
      })
  }

  const glVoid = async (tran) => {
    const results = await dataApi.rpc('glVoid', { ids: [tran.id] })
    results.ok ? growl.success(results.title) : problemHandler.handleError(results)
    return results
  }

  const goToAdjust = async (tran) => {
    f7.views.main.router.navigate(`/ar/trans/${tran.id}/adjust`)
  }

  return {
    payTranHeader,
    memoTranHeader,
    invTranHeader,
    disputePopoverSchema,
    reverse,
    checkImage,
    // glVoid,
    goToAdjust,
    popverId
  }
}
const popverId = 'actions-popover'

const defaultToolbarOpts = (tran) => ({
  rightButtons: {
    createUpdate: {
      icon: 'badge',
      tooltip: 'Created Info',
      component: CreateEditInfo,
      params: { entityId: tran.id, entityType: 'ar/tran' }
    }
  }
})

export function getMemoTranHeader(user) {
  const config = {
    card1: [
      { key: 'dueDate', format: 'date' },
      { label: 'Trans Date', key: 'tranDate', format: 'date' },
      { label: 'Trans Type', key: 'tranType.name' },
      { label: 'PO Num', key: 'ponum' },
      //{ label: 'Created By Payment', key:'autoCash.createdByPayNum'},
      { label: 'Trans Num', key: 'refnum' }, //till we add it to the header
      { label: 'SO Num', key: 'refnum2' },
      { label: 'Orig Trans Num', key: 'origRefnum' },
      { label: 'Created By ArBatch', key: 'createdArBatch.id' },
      { label: 'Comments', key: 'comments' }
    ],
    card2: [
      { label: 'Balance', key: 'amount', format: 'money', class: 'font-bold' }, //RNDC custom (Balance Amount)
      { label: 'Orig Amount', key: 'origAmount', format: 'money', class: 'font-bold' },
      { label: 'Status', key: 'status.code' },
      { label: 'Term', key: 'term.name' },
      { label: 'Gross Amount', key: 'flex.num1', format: 'money' }, //RNDC custom (Alpha only))
      { label: 'Tax Amount', key: 'lineSum.taxAmount', format: 'money' }, //RNDC custom (Alpha only))
      { label: 'Disc Amount', key: 'flex.num2', format: 'money' }, //RNDC custom (Alpha only))
      //    { key:'state' },
      { label: 'Order Type', key: 'flex.text1' }, //RNDC custom
      { label: 'Bill To Loc', key: 'flex.text4' }, //RNDC custom
      { label: 'Misc. Ref Num', key: 'flex.text2' } //RNDC custom
    ]
  }
  //hack for cust for now
  return getUser().isCustomer ? custConfig : config
}

export function getPayTranHeader() {
  const payTranHeader = {
    card1: [
      { label: 'Date', key: 'tranDate', format: 'date' },
      { label: 'Type', key: 'tranType.name' },
      { label: 'Num', key: 'refnum' }, //till we add it to the header
      // { label: 'SO Num', key:'refnum2'},
      // { label: 'Orig Trans Num', key:'origRefnum'},

      { label: 'Comments', key: 'comments', itemClass: 'hide-if-null' }
    ],
    card2: [
      { label: 'Amount', key: 'origAmount', format: 'money-abs$', class: 'font-bold' },
      { label: 'Unapplied', key: 'amount', format: 'money-abs$' }, //RNDC custom (Balance Amount)
      { label: 'Status', key: 'status.code' },
      { label: 'Source Batch', key: 'createdArBatchId', itemClass: 'hide-if-null' }
    ]
  }
  return payTranHeader
}

export function getDisputePopoverSchema() {
  let editSchema = {
    'dispute.reason': {
      input: 'select',
      options: {
        isValueObject: true,
        dataApi: {
          key: 'ar.reason',
          q: {
            $or: [{ restrictUpdate: '$isNull' }, { restrictUpdate: 2 }]
          }
        }
      }
    },
    'dispute.amount': {
      type: 'number',
      format: 'money'
    },
    'dispute.note': {
      maxLength: 1000
    }
  }
  return editSchema
}

export function getInvToolbarOpts(tran) {
  //hide for now
  const tbOpts = {
    leftButtons: {
      showInvoice: {
        icon: 'receipt',
        tooltip: 'Show Invoice'
      },
      dispute: {
        icon: 'balance',
        tooltip: 'Dispute',
        popoverId: 'dispute-popover-edit'
      },
      pay: {
        icon: 'payments',
        tooltip: 'Pay'
        // class: "button-outline"
      }
    }
  }
  const defaultOpts = defaultToolbarOpts(tran)

  return defaultOpts
}

export function getMemoToolbarOpts(tran) {
  //hide for now
  const defaultOpts = defaultToolbarOpts(tran)

  return defaultOpts
}

export function getCreditToolbarOpts(tran) {
  //hide for now
  const defaultOpts = {
    rightButtons: { ...defaultToolbarOpts(tran).rightButtons },
    leftButtons: {
      ...defaultToolbarOpts(tran).leftButtons,
      goToAdjust: {
        icon: 'point_of_sale',
        tooltip: 'Adjust',
        params: { tranId: tran.id }
      }
    }
  }

  return defaultOpts
}
export function getPayToolbarOpts(tran, user) {
  const tbOpts = {
    leftButtons: {
      //before enable make sure users cannot call it twice (double click).
      // reverse: {
      //   icon: "history",
      //   tooltip: "Reverse"
      // }
    }
  }

  if (tran && showActions(tran, user)) {
    tbOpts.leftButtons.glVoid = {
      title: 'Gl Void',
      icon: 'menu',
      tooltip: '',
      color: 'primary',
      class: 'text-primary',
      popoverId: `#${popverId}`,
    };
  }

  if (tran && tran.docType === 'PA' && get(tran, 'autoCash.imageFileName')) {
    tbOpts.leftButtons.checkImage = {
      icon: 'image',
      tooltip: 'Check Image'
    }
  }
  tbOpts.leftButtons = { ...tbOpts.leftButtons, ...defaultToolbarOpts(tran).leftButtons }
  tbOpts.rightButtons = { ...defaultToolbarOpts(tran).rightButtons }
  return tbOpts
}

export const custConfig = {
  card1: [
    { key: 'dueDate', format: 'date' },
    { label: 'Trans Date', key: 'tranDate', format: 'date' },
    { label: 'Trans Type', key: 'tranType.name' },
    { label: 'PO Num', key: 'ponum' }
    //{ label: 'Created By Payment', key:'autoCash.createdByPayNum'},
    // { label: 'Trans Num', key:'refnum'},  //till we add it to the header
  ],
  card2: [
    { label: 'Balance', key: 'amount', format: 'money$' }, //RNDC custom (Balance Amount)
    { label: 'Orig Amount', key: 'origAmount', format: 'money$' },
    //  { label: 'Gross Amount', key:'flex.num1', type: 'amount', input: 'amount'},    //RNDC custom (Alpha only))
    //  { label: 'Disc Amount', key:'discAmount', type: 'amount', input: 'amount'}, //RNDC custom (Alpha only))
    //    { key:'state' },
    { label: 'Status', key: 'status.code' },
    { label: 'Terms', key: 'term.name' }
  ]
}

function showActions(tran, user) {
  return user.isAutocashManager && tran.state === 0
}
